'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _grid = require('../grid');

exports['default'] = _grid.Col;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/col/index.js
// module id = 633
// module chunks = 0